import { Form, Input } from 'antd'

const StepThree = () => {
    return (
        <Form.Item
            label="Insira sua senha"
            name="password"
            rules={[{ required: true }]}
        >
            <Input.Password placeholder="Senha" />
        </Form.Item>
    )
}

export default StepThree
